var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6785 21.5089C18.3066 21.5089 23.5743 13.5302 23.5743 6.61311C23.5743 6.3888 23.5693 6.15952 23.5593 5.93521C24.5841 5.19415 25.4684 4.27624 26.1707 3.22462C25.2164 3.64922 24.2031 3.92653 23.1656 4.04707C24.258 3.39222 25.076 2.36348 25.4679 1.15155C24.4402 1.76064 23.3162 2.1903 22.1442 2.42211C21.3546 1.58306 20.3105 1.02751 19.1734 0.84135C18.0364 0.655191 16.8697 0.848792 15.8537 1.39222C14.8377 1.93565 14.029 2.79864 13.5526 3.84777C13.0763 4.89689 12.9588 6.07372 13.2184 7.1963C11.1374 7.09187 9.10148 6.55127 7.24276 5.60954C5.38405 4.66782 3.74398 3.34599 2.42888 1.72976C1.76048 2.88216 1.55595 4.24582 1.85686 5.54361C2.15776 6.84139 2.94153 7.97591 4.04886 8.71658C3.21754 8.69019 2.40443 8.46637 1.67672 8.06361V8.12841C1.67597 9.33776 2.09406 10.5101 2.85991 11.446C3.62576 12.382 4.69211 13.0238 5.87768 13.2625C5.1076 13.4732 4.29936 13.5039 3.51551 13.3522C3.85006 14.3923 4.50097 15.3019 5.37739 15.9542C6.25382 16.6065 7.31203 16.969 8.40435 16.9909C6.54992 18.4476 4.25916 19.2377 1.90102 19.234C1.48282 19.2333 1.06504 19.2077 0.649902 19.1572C3.04552 20.6941 5.83226 21.5104 8.6785 21.5089Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.cbd3c299.svg";
export { ForwardRef as ReactComponent };